import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";

@Component({
  selector: 'app-updaterecord',
  templateUrl: './updaterecord.component.html',
  styleUrls: ['./updaterecord.component.css']
})
export class UpdaterecordComponent implements OnInit {
  apiUrl: string; 
  status: boolean = false;
  dtOptions: any = {};
  submitted = false; 
 
  outboundForm: FormGroup;
  appointmentForm: FormGroup;
  passportDetails: any;
  passportNumber: any;
  travelType: any;
  appointmentId: string;
  inboundForm: FormGroup;
  collectionCenters: any;
  lgas: any;

  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
    ) { }

  ngOnInit() {
    this.getLgas()
    this.getCollectionCenters()
     this.initAppointmentForm()
     this.initUpdateForm() 
  }

  initUpdateForm(){
  
    this.outboundForm = this.formBuilder.group({
      travelType: ["",[Validators.required]],
      center: ["",[Validators.required]],
      passportNumber: ["",[Validators.required, Validators.minLength(8)]],
      appointmentId: ["",[Validators.required, Validators.minLength(11)]],
      bookingDate: ["",[Validators.required]],
      bookingTime: ["",[Validators.required]],
      // outbound
      lga: ["",[Validators.required]],
      departureDate: ["",[Validators.required]],
      preferredState: ["",[Validators.required]], 
    });

    this.inboundForm = this.formBuilder.group({
      travelType: ["",[Validators.required]],
      center: ["",[Validators.required]],
      passportNumber: ["",[Validators.required, Validators.minLength(8)]],
      appointmentId: ["",[Validators.required, Validators.minLength(11)]],
      bookingDate: ["",[Validators.required]],
      bookingTime: ["",[Validators.required]], 
      // inbound
      arrivalDate: ["",[Validators.required]],
      expectedCity: ["",[Validators.required]],
      expectedState: ["",[Validators.required]],
    });
  }

  initOutboundForm(passport, travel, booking){
    this.outboundForm = this.formBuilder.group({
      travelType: [travel.type,[Validators.required]],
      center: [booking.center_id,[Validators.required]],
      passportNumber: [passport.passport_no,[Validators.required, Validators.minLength(8)]],
      appointmentId: [passport.ctms_passenger_id,[Validators.required, Validators.minLength(11)]],
      bookingTime: [booking.booking_time,[Validators.required]],
      bookingDate: [booking.booking_date,[Validators.required]],
      name: [passport.first_name+ " " + passport.middle_name+ " " + passport.last_name ,[Validators.required]], 
      phone: [passport.phone,[Validators.required]], 
      email: [passport.email,[Validators.required]],
      // outbound
      lga: [booking.lga_code_id,[Validators.required]],
      departureDate: [travel.departure_date,[Validators.required]],
      preferredState: [booking.prefer_state,[Validators.required]], 
    });
  }

  initInboundForm(passport, travel, booking){
    this.inboundForm = this.formBuilder.group({
      travelType: [travel.type,[Validators.required]],
      center: [booking.center_id,[Validators.required]],
      passportNumber: [passport.passport_no,[Validators.required, Validators.minLength(8)]],
      appointmentId: [passport.ctms_passenger_id,[Validators.required, Validators.minLength(11)]],
      bookingDate: [booking.booking_date,[Validators.required]],
      bookingTime: [booking.booking_time,[Validators.required]],
      name: [passport.first_name+ " " + passport.middle_name+ " " + passport.last_name ,[Validators.required]], 
      phone: [passport.phone,[Validators.required]], 
      email: [passport.email,[Validators.required]], 
      // inbound
      arrivalDate: [travel.arrival_date,[Validators.required]],
      expectedCity: [booking.expected_city,[Validators.required]],
      expectedState: [booking.expected_state,[Validators.required]],
    });
  }

   initAppointmentForm(){
    this.appointmentForm = this.formBuilder.group({ 
      appointmentId: ["", [Validators.minLength(7), Validators.required,
      Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),Validators.maxLength(15)]],
    });
  }

  viewModal(modal){
    this.utility.showModal(modal);

  }

  submitForm(formData){
    this.submitted = true

    if(this.appointmentForm.invalid){
     return  
    }

    this.getPassportDetails()
    this.submitted =false
  }

  getPassportDetails() {
    let obj = {}; 
    this.appointmentId = this.appointmentForm.get("appointmentId").value
      this.spinnerService.show(); 
        this.apiUrl =
          environment.AUTHAPIURL +
          "passenger-get-record/" +
          this.appointmentId;

        this.http.get<any>(this.apiUrl).subscribe((data) => {
          console.log("appointmentDetails: ", data);
          if (data.status == true) {
            this.passportDetails = data.response;
            this.travelType = data.response.travel_info.type
            this.spinnerService.hide();
            
            if(this.travelType == 2){
              this.initInboundForm(
                this.passportDetails.passenger_info, 
                this.passportDetails.travel_info,
                this.passportDetails.booking_info
              ); 
              document.getElementById('loadInboundModal').click()
            
            }else{
              this.initOutboundForm(
                this.passportDetails.passenger_info, 
                this.passportDetails.travel_info,
                this.passportDetails.booking_info
              ); 
              document.getElementById('loadOutboundModal').click()
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: data.message,
              showConfirmButton: true,
              timer: 4000,
            }); 
            this.spinnerService.hide();
          }
        });
       
  }

  submitInboundForm(formdata){
    this.submitted = true

    if(this.inboundForm.invalid){
      return
    }
    const obj = {
      passenger_info: {
        ctms_passenger_id : this.appointmentId
      },
      travel_info:{
        type: formdata.travelType,
        arrival_date: formdata.arrivalDate
      },
      booking_info: {
        booking_date: formdata.bookingDate,
        booking_time: formdata.bookingTime,
        center_id: formdata.center,
        expected_state: formdata.expectedState,
        expected_city: formdata.expectedCity,
      }
    }

    this.postInboundRecord(obj)
    this.submitted =false
  }
  
  postInboundRecord(jsondata){
    this.spinnerService.show(); 
        this.apiUrl =
          environment.AUTHAPIURL +
          "passenger-update-record" 

        this.http.post<any>(this.apiUrl, jsondata).subscribe((data) => {
          // console.log("appointmentDetails: ", data);
          if (data.status == true) { 
            this.spinnerService.hide();
            Swal.fire({
              icon: "success",
              title: "Success",
              text: data.message,
              showConfirmButton: true,
              timer: 4000,
            });  
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: data.response != null ? data.response[0].message : data.message,
              showConfirmButton: true,
              timer: 4000,
            }); 
            this.spinnerService.hide();
          }
        });
  }

  submitOutboundForm(formdata){
    this.submitted = true

    if(this.outboundForm.invalid){
      return
    }
    const obj = {
      passenger_info: {
        ctms_passenger_id : this.appointmentId
      },
      travel_info:{
        type: formdata.travelType,
        departure_date: formdata.departureDate
      },
      booking_info: {
        booking_date: formdata.bookingDate,
        booking_time: formdata.bookingTime,
        center_id: formdata.center,
        prefer_state: formdata.preferredState,
        lga_code_id: formdata.lga,
      }
    }

    this.postOutboundRecord(obj)
    this.submitted =false
  }
  
  postOutboundRecord(jsondata){
    this.spinnerService.show(); 
    this.apiUrl =
      environment.AUTHAPIURL +
      "passenger-update-record" 

    this.http.post<any>(this.apiUrl, jsondata).subscribe((data) => {
      // console.log("appointmentDetails: ", data);
      if (data.status == true) { 
        this.spinnerService.hide();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message,
          showConfirmButton: true,
          timer: 4000,
        });  
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.response != null ? data.response[0].message : data.message,
          showConfirmButton: true,
          timer: 4000,
        }); 
        this.spinnerService.hide();
      }
    }); 
  }

  getLgas() {
		this.apiUrl = environment.AUTHAPIURL + 'lga-list';
		const obj = {};
		this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
			console.log('lga: ', data);
			this.lgas = data.response;
		});
	}

	getCollectionCenters() {
		this.apiUrl = environment.AUTHAPIURL + 'collection-center-list?page=1';

		const obj = {
			per_page: 100,
		};
		this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
			console.log('collectionCenters: ', data);
			this.collectionCenters = data.response;
		});
	}
}